import ImageCanvasProcessor from './ImageCanvasProcessor';

export default ImageCanvasProcessor;
